export default "__VITE_ASSET__BPTHAv2Q__"